import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  prefix?: string;
}
export function Input({
  label,
  error,
  className = '',
  prefix,
  type,
  onChange,
  ...props
}: InputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === 'number') {
      const val = e.target.value;
      // Allow empty string (clearing the field)
      if (val === '') {
        onChange?.(e);
        return;
      }
      // Prevent negative values
      const num = parseFloat(val);
      if (num < 0) {
        return;
      }
    }
    onChange?.(e);
  };
  return <div className="w-full" data-id="element-34">
      {label && <label className="mb-1.5 block text-sm font-medium text-gray-700" data-id="element-35">
          {label}
        </label>}
      <div className="relative" data-id="element-36">
        {prefix && <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-37">
            <span className="text-gray-500 sm:text-sm" data-id="element-38">{prefix}</span>
          </div>}
        <input type={type} className={`flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 transition-shadow ${prefix ? 'pl-7' : ''} ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} onChange={handleChange} min={type === 'number' ? '0' : undefined} step={type === 'number' ? 'any' : undefined} {...props} data-id="element-39" />
      </div>
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-40">{error}</p>}
    </div>;
}